"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.SportEvent = void 0;
const flatbuffers = require("flatbuffers");
const avbetradar_stream_js_1 = require("../../sportsbook/actual/avbetradar-stream.js");
const competitor_js_1 = require("../../sportsbook/actual/competitor.js");
const igame_stream_js_1 = require("../../sportsbook/actual/igame-stream.js");
const market_js_1 = require("../../sportsbook/actual/market.js");
const perform_js_1 = require("../../sportsbook/actual/perform.js");
const sport_event_live_odds_js_1 = require("../../sportsbook/actual/sport-event-live-odds.js");
const sport_event_se_type_js_1 = require("../../sportsbook/actual/sport-event-se-type.js");
const sport_event_top_type_js_1 = require("../../sportsbook/actual/sport-event-top-type.js");
const sport_event_type_js_1 = require("../../sportsbook/actual/sport-event-type.js");
class SportEvent {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSportEvent(bb, obj) {
        return (obj || new SportEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSportEvent(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SportEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : sport_event_type_js_1.SportEventType.match;
    }
    provider() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    seType() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : sport_event_se_type_js_1.SportEventSeType.match;
    }
    liveodds() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : sport_event_live_odds_js_1.SportEventLiveOdds.booked;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    status() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 0;
    }
    weight() {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    sportId() {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    categoryId() {
        const offset = this.bb.__offset(this.bb_pos, 22);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    tournamentId() {
        const offset = this.bb.__offset(this.bb_pos, 24);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    scheduled() {
        const offset = this.bb.__offset(this.bb_pos, 26);
        return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt('0');
    }
    timestamp() {
        const offset = this.bb.__offset(this.bb_pos, 28);
        return offset ? this.bb.readUint64(this.bb_pos + offset) : BigInt('0');
    }
    activeMarketsCount() {
        const offset = this.bb.__offset(this.bb_pos, 30);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    competitors(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 32);
        return offset ? (obj || new competitor_js_1.Competitor()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    competitorsLength() {
        const offset = this.bb.__offset(this.bb_pos, 32);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    markets(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 34);
        return offset ? (obj || new market_js_1.Market()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    marketsLength() {
        const offset = this.bb.__offset(this.bb_pos, 34);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    match(index) {
        const offset = this.bb.__offset(this.bb_pos, 36);
        return offset ? this.bb.readUint8(this.bb.__vector(this.bb_pos + offset) + index) : 0;
    }
    matchLength() {
        const offset = this.bb.__offset(this.bb_pos, 36);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    matchArray() {
        const offset = this.bb.__offset(this.bb_pos, 36);
        return offset ? new Uint8Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    tournamentRoundType(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 38);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    tournamentRoundLevel(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 40);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    tournamentRoundNumber() {
        const offset = this.bb.__offset(this.bb_pos, 42);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    video(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 44);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    stats() {
        const offset = this.bb.__offset(this.bb_pos, 46);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    dicePlatformId() {
        const offset = this.bb.__offset(this.bb_pos, 48);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    perform(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 50);
        return offset ? (obj || new perform_js_1.Perform()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    performLength() {
        const offset = this.bb.__offset(this.bb_pos, 50);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    tSettingsType() {
        const offset = this.bb.__offset(this.bb_pos, 52);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    tSettingsList(index) {
        const offset = this.bb.__offset(this.bb_pos, 54);
        return offset ? this.bb.readUint32(this.bb.__vector(this.bb_pos + offset) + index * 4) : 0;
    }
    tSettingsListLength() {
        const offset = this.bb.__offset(this.bb_pos, 54);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    tSettingsListArray() {
        const offset = this.bb.__offset(this.bb_pos, 54);
        return offset ? new Uint32Array(this.bb.bytes().buffer, this.bb.bytes().byteOffset + this.bb.__vector(this.bb_pos + offset), this.bb.__vector_len(this.bb_pos + offset)) : null;
    }
    tags(index, optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 56);
        return offset ? this.bb.__string(this.bb.__vector(this.bb_pos + offset) + index * 4, optionalEncoding) : null;
    }
    tagsLength() {
        const offset = this.bb.__offset(this.bb_pos, 56);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    iGameEventId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 58);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    iGameStreams(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 60);
        return offset ? (obj || new igame_stream_js_1.IGameStream()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    iGameStreamsLength() {
        const offset = this.bb.__offset(this.bb_pos, 60);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    extraIsInHostedStatistics(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 62);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    extraIsInLiveScore(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 64);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    extraIsInLiveMatchTracker(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 66);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    extraLinkName(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 68);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    extraLinkRef(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 70);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    topEventType() {
        const offset = this.bb.__offset(this.bb_pos, 72);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : sport_event_top_type_js_1.SportEventTopType.none;
    }
    customSportId() {
        const offset = this.bb.__offset(this.bb_pos, 74);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    customCategoryId() {
        const offset = this.bb.__offset(this.bb_pos, 76);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    customTournamentId() {
        const offset = this.bb.__offset(this.bb_pos, 78);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    avbetradarId(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 80);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    avbetradarStreams(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 82);
        return offset ? (obj || new avbetradar_stream_js_1.AvbetradarStream()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    avbetradarStreamsLength() {
        const offset = this.bb.__offset(this.bb_pos, 82);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    sportlevel(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 84);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    bigsports(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 86);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startSportEvent(builder) {
        builder.startObject(42);
    }
    static addId(builder, id) {
        builder.addFieldInt32(0, id, 0);
    }
    static addType(builder, type) {
        builder.addFieldInt8(1, type, sport_event_type_js_1.SportEventType.match);
    }
    static addProvider(builder, provider) {
        builder.addFieldInt8(2, provider, 1);
    }
    static addSeType(builder, seType) {
        builder.addFieldInt8(3, seType, sport_event_se_type_js_1.SportEventSeType.match);
    }
    static addLiveodds(builder, liveodds) {
        builder.addFieldInt8(4, liveodds, sport_event_live_odds_js_1.SportEventLiveOdds.booked);
    }
    static addState(builder, state) {
        builder.addFieldInt8(5, state, 1);
    }
    static addStatus(builder, status) {
        builder.addFieldInt8(6, status, 0);
    }
    static addWeight(builder, weight) {
        builder.addFieldInt8(7, weight, 0);
    }
    static addSportId(builder, sportId) {
        builder.addFieldInt32(8, sportId, 0);
    }
    static addCategoryId(builder, categoryId) {
        builder.addFieldInt32(9, categoryId, 0);
    }
    static addTournamentId(builder, tournamentId) {
        builder.addFieldInt32(10, tournamentId, 0);
    }
    static addScheduled(builder, scheduled) {
        builder.addFieldInt64(11, scheduled, BigInt('0'));
    }
    static addTimestamp(builder, timestamp) {
        builder.addFieldInt64(12, timestamp, BigInt('0'));
    }
    static addActiveMarketsCount(builder, activeMarketsCount) {
        builder.addFieldInt16(13, activeMarketsCount, 0);
    }
    static addCompetitors(builder, competitorsOffset) {
        builder.addFieldOffset(14, competitorsOffset, 0);
    }
    static createCompetitorsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startCompetitorsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addMarkets(builder, marketsOffset) {
        builder.addFieldOffset(15, marketsOffset, 0);
    }
    static createMarketsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startMarketsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addMatch(builder, matchOffset) {
        builder.addFieldOffset(16, matchOffset, 0);
    }
    static createMatchVector(builder, data) {
        builder.startVector(1, data.length, 1);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt8(data[i]);
        }
        return builder.endVector();
    }
    static startMatchVector(builder, numElems) {
        builder.startVector(1, numElems, 1);
    }
    static addTournamentRoundType(builder, tournamentRoundTypeOffset) {
        builder.addFieldOffset(17, tournamentRoundTypeOffset, 0);
    }
    static addTournamentRoundLevel(builder, tournamentRoundLevelOffset) {
        builder.addFieldOffset(18, tournamentRoundLevelOffset, 0);
    }
    static addTournamentRoundNumber(builder, tournamentRoundNumber) {
        builder.addFieldInt16(19, tournamentRoundNumber, 0);
    }
    static addVideo(builder, videoOffset) {
        builder.addFieldOffset(20, videoOffset, 0);
    }
    static addStats(builder, stats) {
        builder.addFieldInt16(21, stats, 0);
    }
    static addDicePlatformId(builder, dicePlatformId) {
        builder.addFieldInt32(22, dicePlatformId, 0);
    }
    static addPerform(builder, performOffset) {
        builder.addFieldOffset(23, performOffset, 0);
    }
    static createPerformVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startPerformVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addTSettingsType(builder, tSettingsType) {
        builder.addFieldInt16(24, tSettingsType, 0);
    }
    static addTSettingsList(builder, tSettingsListOffset) {
        builder.addFieldOffset(25, tSettingsListOffset, 0);
    }
    static createTSettingsListVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addInt32(data[i]);
        }
        return builder.endVector();
    }
    static startTSettingsListVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addTags(builder, tagsOffset) {
        builder.addFieldOffset(26, tagsOffset, 0);
    }
    static createTagsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startTagsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addIGameEventId(builder, iGameEventIdOffset) {
        builder.addFieldOffset(27, iGameEventIdOffset, 0);
    }
    static addIGameStreams(builder, iGameStreamsOffset) {
        builder.addFieldOffset(28, iGameStreamsOffset, 0);
    }
    static createIGameStreamsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startIGameStreamsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addExtraIsInHostedStatistics(builder, extraIsInHostedStatisticsOffset) {
        builder.addFieldOffset(29, extraIsInHostedStatisticsOffset, 0);
    }
    static addExtraIsInLiveScore(builder, extraIsInLiveScoreOffset) {
        builder.addFieldOffset(30, extraIsInLiveScoreOffset, 0);
    }
    static addExtraIsInLiveMatchTracker(builder, extraIsInLiveMatchTrackerOffset) {
        builder.addFieldOffset(31, extraIsInLiveMatchTrackerOffset, 0);
    }
    static addExtraLinkName(builder, extraLinkNameOffset) {
        builder.addFieldOffset(32, extraLinkNameOffset, 0);
    }
    static addExtraLinkRef(builder, extraLinkRefOffset) {
        builder.addFieldOffset(33, extraLinkRefOffset, 0);
    }
    static addTopEventType(builder, topEventType) {
        builder.addFieldInt8(34, topEventType, sport_event_top_type_js_1.SportEventTopType.none);
    }
    static addCustomSportId(builder, customSportId) {
        builder.addFieldInt32(35, customSportId, 0);
    }
    static addCustomCategoryId(builder, customCategoryId) {
        builder.addFieldInt32(36, customCategoryId, 0);
    }
    static addCustomTournamentId(builder, customTournamentId) {
        builder.addFieldInt32(37, customTournamentId, 0);
    }
    static addAvbetradarId(builder, avbetradarIdOffset) {
        builder.addFieldOffset(38, avbetradarIdOffset, 0);
    }
    static addAvbetradarStreams(builder, avbetradarStreamsOffset) {
        builder.addFieldOffset(39, avbetradarStreamsOffset, 0);
    }
    static createAvbetradarStreamsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startAvbetradarStreamsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static addSportlevel(builder, sportlevelOffset) {
        builder.addFieldOffset(40, sportlevelOffset, 0);
    }
    static addBigsports(builder, bigsportsOffset) {
        builder.addFieldOffset(41, bigsportsOffset, 0);
    }
    static endSportEvent(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSportEvent(builder, id, type, provider, seType, liveodds, state, status, weight, sportId, categoryId, tournamentId, scheduled, timestamp, activeMarketsCount, competitorsOffset, marketsOffset, matchOffset, tournamentRoundTypeOffset, tournamentRoundLevelOffset, tournamentRoundNumber, videoOffset, stats, dicePlatformId, performOffset, tSettingsType, tSettingsListOffset, tagsOffset, iGameEventIdOffset, iGameStreamsOffset, extraIsInHostedStatisticsOffset, extraIsInLiveScoreOffset, extraIsInLiveMatchTrackerOffset, extraLinkNameOffset, extraLinkRefOffset, topEventType, customSportId, customCategoryId, customTournamentId, avbetradarIdOffset, avbetradarStreamsOffset, sportlevelOffset, bigsportsOffset) {
        SportEvent.startSportEvent(builder);
        SportEvent.addId(builder, id);
        SportEvent.addType(builder, type);
        SportEvent.addProvider(builder, provider);
        SportEvent.addSeType(builder, seType);
        SportEvent.addLiveodds(builder, liveodds);
        SportEvent.addState(builder, state);
        SportEvent.addStatus(builder, status);
        SportEvent.addWeight(builder, weight);
        SportEvent.addSportId(builder, sportId);
        SportEvent.addCategoryId(builder, categoryId);
        SportEvent.addTournamentId(builder, tournamentId);
        SportEvent.addScheduled(builder, scheduled);
        SportEvent.addTimestamp(builder, timestamp);
        SportEvent.addActiveMarketsCount(builder, activeMarketsCount);
        SportEvent.addCompetitors(builder, competitorsOffset);
        SportEvent.addMarkets(builder, marketsOffset);
        SportEvent.addMatch(builder, matchOffset);
        SportEvent.addTournamentRoundType(builder, tournamentRoundTypeOffset);
        SportEvent.addTournamentRoundLevel(builder, tournamentRoundLevelOffset);
        SportEvent.addTournamentRoundNumber(builder, tournamentRoundNumber);
        SportEvent.addVideo(builder, videoOffset);
        SportEvent.addStats(builder, stats);
        SportEvent.addDicePlatformId(builder, dicePlatformId);
        SportEvent.addPerform(builder, performOffset);
        SportEvent.addTSettingsType(builder, tSettingsType);
        SportEvent.addTSettingsList(builder, tSettingsListOffset);
        SportEvent.addTags(builder, tagsOffset);
        SportEvent.addIGameEventId(builder, iGameEventIdOffset);
        SportEvent.addIGameStreams(builder, iGameStreamsOffset);
        SportEvent.addExtraIsInHostedStatistics(builder, extraIsInHostedStatisticsOffset);
        SportEvent.addExtraIsInLiveScore(builder, extraIsInLiveScoreOffset);
        SportEvent.addExtraIsInLiveMatchTracker(builder, extraIsInLiveMatchTrackerOffset);
        SportEvent.addExtraLinkName(builder, extraLinkNameOffset);
        SportEvent.addExtraLinkRef(builder, extraLinkRefOffset);
        SportEvent.addTopEventType(builder, topEventType);
        SportEvent.addCustomSportId(builder, customSportId);
        SportEvent.addCustomCategoryId(builder, customCategoryId);
        SportEvent.addCustomTournamentId(builder, customTournamentId);
        SportEvent.addAvbetradarId(builder, avbetradarIdOffset);
        SportEvent.addAvbetradarStreams(builder, avbetradarStreamsOffset);
        SportEvent.addSportlevel(builder, sportlevelOffset);
        SportEvent.addBigsports(builder, bigsportsOffset);
        return SportEvent.endSportEvent(builder);
    }
}
exports.SportEvent = SportEvent;
